module.exports = __webpack_public_path__ + "assets/img/fork.5b9e58b5.png";